const mEditionAcademyLegalsTermsAndConditions = {
  mEditionAcademyLegalsTermsAndConditions: {
    alerts: {
      updateAcademiaLegales: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos legales para Términos y Condiciones fueron guardados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      text: {
        label: 'Términos y Condiciones'
      }
    }
  }
}

export default mEditionAcademyLegalsTermsAndConditions
